import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
	List,
	ListItem,
	ListItemText,
	ListSubheader,
	Divider,
} from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
	root: {
		width: '100%',
		maxWidth: 360,
		backgroundColor: theme.palette.background.paper,
	},
}));

const SubProductList = ({ subProducts, handleSelectSubProduct }) => {
	const classes = useStyles();

	const [listValue, setListValue] = useState({
		subProducts: [],
	});

	useEffect(() => {
		setListValue({
			subProducts: subProducts,
		});
	}, [subProducts]);

	return (
		<List
			className={classes.root}
			subheader={<ListSubheader>副商品列表</ListSubheader>}
		>
			{listValue.subProducts?.map((product, index) => {
				var imageToShow =
					product.image && (product.image.url || product.image.blob);
				return (
					<div key={index}>
						<Divider />
						<ListItem
							onClick={() => {
								handleSelectSubProduct(product);
							}}
						>
							<ListItemText
								primary={`副商品名称：${product.name}`}
								secondary={`价格：${product.price}, 库存: ${product.numberOfStock}`}
							/>
							{imageToShow ? (
								<div style={{ height: '50px', width: '50px' }}>
									<img
										style={{ height: '100%', width: '100%' }}
										src={imageToShow}
										alt={'null'}
									/>
								</div>
							) : null}
						</ListItem>
					</div>
				);
			})}
		</List>
	);
};

SubProductList.propTypes = {
	subProducts: PropTypes.array,
};

export default SubProductList;
